

















































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import subscriptionApi, { SubscriptionApi } from '@/views/settings/subscription/api';
import ChangePlanItem from '@/views/settings/subscription/forms/change-plan/change-plan-item.vue';
import LoadingCircle from '@/components/loading-circle.vue';

@Component({
  components: {
    ChangePlanItem,
    LoadingCircle,
  }
})
export default class CustomConversions extends mixins<PlanLimitsMixin>(PlanLimitsMixin) {
  api: SubscriptionApi = subscriptionApi;
  loading:boolean = false;

  mounted(){
    this.loading = true;
    this.api.getPlans().then(()=>this.loading=false);
  }

  get selectedPlanId() {
    return this.$store.state.billing.planId
  }

  get plansList() {
    return this.$store.state.billingPlans
  }

  get blockRowsFiltered() {
    const existedKeysInFirstPlan = this.$store.state.billingPlans[0].limits
    return this.planLimitsKeysGrouping.map(block=>{
      const filteredKeys = block.keys.filter(key=>key in existedKeysInFirstPlan)
      return {
        ...block,
        keys:filteredKeys
      }
    }).filter(item=>!item.name.includes('Data retention'))
  }

  selectPlan(plan:Billing.BillingPlan){
    return this.bus.emit('open-dialog',{
      name: 'ChangePlanDialog',
      data: {
        preSelectedPlan: plan,
      }
    });
  }
}
